import { AfterViewInit, Directive, ElementRef } from '@angular/core';

// eslint-disable-next-line @angular-eslint/directive-selector
@Directive({ selector: '[focus]' })
export class FocusDirective implements AfterViewInit {
  constructor(private host: ElementRef) {}

  ngAfterViewInit(): void {
    if (this.host) {
      const input = this.host.nativeElement.querySelector('input');
      if (input) {
        setTimeout(() => input.focus(), 200);
      }
    }
  }
}
